import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}

export default function SEO({
  title,
  description,
  keywords = "software development company UAE, web design Dubai, mobile app development Sharjah, digital marketing UAE",
  ogImage = "https://images.unsplash.com/photo-1518709268805-4e9042af2176",
  ogType = "website",
  canonical
}: SEOProps) {
  const fullTitle = title.includes("ZeeX Soft") ? title : `${title} | ZeeX Soft - We Architect Tomorrow's Tech`;
  const url = canonical || (typeof window !== 'undefined' ? window.location.href : 'https://zeexsoft.com');

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="ZeeX Soft" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="ZeeX Soft" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="canonical" href={url} />
      
      {/* Schema.org structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareCompany",
          "name": "ZeeX Soft",
          "description": "Leading software development company in UAE offering web development, mobile apps, and digital solutions.",
          "url": "https://zeexsoft.com",
          "logo": "https://zeexsoft.com/logo.png",
          "sameAs": [
            "https://www.linkedin.com/company/zeexsoft",
            "https://twitter.com/zeexsoft"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Almawarid Building 209, Industrial Area 3",
            "addressLocality": "Sharjah",
            "addressCountry": "UAE"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+44 7743 307781",
            "contactType": "customer service",
            "email": "info@zeexsoft.com"
          }
        })}
      </script>
    </Helmet>
  );
}
